import { render, staticRenderFns } from "./ShelfLabel.vue?vue&type=template&id=328297df&scoped=true&"
import script from "./ShelfLabel.vue?vue&type=script&lang=js&"
export * from "./ShelfLabel.vue?vue&type=script&lang=js&"
import style0 from "./ShelfLabel.vue?vue&type=style&index=0&id=328297df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328297df",
  null
  
)

export default component.exports